import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faPhone, faCalendarAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import FAQ from '../components/FAQ';
import '../css/Contact.css';
import ReCAPTCHA from 'react-google-recaptcha';

const Contact = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [captchaToken, setCaptchaToken] = useState('');

  const handlePhoneChange = (e) => {
    const input = e.target.value.replace(/\D/g, ""); // Remove all non-digit characters
    const formatted = input.replace(
      /^(\d{3})(\d{0,3})(\d{0,4})$/,
      (match, g1, g2, g3) =>
        `${g1}${g2 ? "-" : ""}${g2}${g3 ? "-" : ""}${g3}`
    );
    setPhoneNumber(formatted);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      alert('Please complete the CAPTCHA.');
      return;
    }

    const formData = new FormData(e.target);
    const response = await fetch('https://bookfunnel-api-fc5e1c1aab92.herokuapp.com/api/send-email', {
      method: 'POST',
      body: JSON.stringify({
        name: formData.get('firstName') + ' ' + formData.get('lastName'),
        email: formData.get('email'),
        phone: formData.get('phone'),
        message: formData.get('message'),
        services: formData.getAll('services'),
        captchaToken,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      alert('Message sent successfully!');
      e.target.reset();
      setCaptchaToken('');
      setPhoneNumber('');
    } else {
      alert('Failed to send message. Please try again.');
    }
  };

  return (
    <Container className="contact-container">
      <Row className="main-contact-section">
        {/* Left Column */}
        <Col md={6} sm={12}>
          {/* How Can We Help Section */}
          <div className="how-can-we-help">
            <h2 className="section-title">How Can We Help?</h2>
            <p className="section-description">
              At FarmHouse Media and Consulting, we empower small businesses in Eastern North Carolina with tailored web development, IT solutions, and business consulting. Whether you're building your first website, enhancing your online strategy, or optimizing operations, we’re here to guide you every step of the way.
            </p>
            <p className="section-description">
              With over a decade of experience, our team is passionate about fostering growth, innovation, and meaningful partnerships that help your business thrive in today’s digital landscape. Let us help you navigate the complexities of the online world and achieve your goals with solutions designed just for you.
            </p>
          </div>

          {/* Connect with Us Section */}
          <div className="connect-with-us">
            <h2 className="section-title">Connect with Us</h2>
            <Button href="tel:2526003642" className="btn">
              <FontAwesomeIcon icon={faPhone} /> Call Us at 252-600-3462
            </Button>
            <Button className="btn" href="https://calendar.app.google/CcgHXkUsKAtYeEjo8" target="_blank">
              <FontAwesomeIcon icon={faCalendarAlt} /> Schedule a Meeting
            </Button>
            <Button href="https://www.facebook.com/profile.php?id=61567655122392" target="_blank" rel="noopener noreferrer" className="btn">
              <FontAwesomeIcon icon={faEnvelope} /> Connect with us on Facebook
            </Button>
          </div>
        </Col>

        {/* Right Column */}
        <Col md={6} sm={12}>
          {/* Get in Touch Form */}
          <div className="get-in-touch">
            <h2 className="section-title">Get in Touch</h2>
            <p>For inquiries regarding services or to contact us, please fill out and submit the form below.</p>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="First Name"
                name="firstName"
                required
                className="form-control"
              />
              <input
                type="text"
                placeholder="Last Name"
                name="lastName"
                required
                className="form-control"
              />
              <input
                type="email"
                name="email"
                placeholder="E-mail"
                required
                className="form-control"
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                title="Please enter a valid email address"
              />
              <input
                type="tel"
                name="phone"
                placeholder="Telephone"
                value={phoneNumber}
                className="form-control"
                onChange={handlePhoneChange}
                pattern="\d{3}-\d{3}-\d{4}"
                required
              />
              <textarea
                placeholder="Details about your project or campaign"
                rows="4"
                className="form-control"
                name="message">
              </textarea>
              <p className="mb-3 mb-md-2">What services are you interested in?</p>
              <div className="checkbox-group">

                <label>
                  <input type="checkbox" name="services" value="Web Development & Design"/> Web Development & Design
                </label>
                <label> 
                  <input type="checkbox" name="services" value="Web Services & Automation"/> Web Services & Automation
                </label>
                <label>
                  <input type="checkbox" name="services" value="E-Commerce Solutions"/> E-Commerce Solutions
                </label>
                <label>
                  <input type="checkbox" name="services" value="Social Media & Digital Marketing"/> Social Media & Digital Marketing
                </label>
                <label>
                  <input type="checkbox" name="services" value="Cloud Hosting Solutions"/> Cloud Hosting Solutions
                </label>
                <label>
                  <input type="checkbox" name="services" value="Business Analytics & Consulting"/> Business Analytics & Consulting
                </label>
              </div>
              <ReCAPTCHA
                sitekey="6LfX2qcqAAAAAIysevJT80xsgqINQiPXSRiF5Jmj"
                onChange={(token) => setCaptchaToken(token)}
                className="my-3"
              />
              <button type="submit" className="btn btn-primary btn-lg">
                Submit
              </button>
            </form>
          </div>
        </Col>

      </Row>

      {/* FAQ Section */}
      <div className="faq-section mt-4">
        <FAQ />
      </div>
    </Container>
  );
};

export default Contact;
